"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var semver = require('semver');
var CATEGORIES = {
  'integration': 'Integration',
  'networking': 'Networking',
  'live': 'Live',
  'learning': 'Learning',
  'content and logistics': 'Content and logistics'
};
var IMAGE_KEYS = ['icon', 'image_1', 'image_2', 'image_3', 'image_4'];
var STAGE_BETA = 'beta';
var getModuleDetailsFields = function getModuleDetailsFields() {
  return {
    name: {
      order: 1,
      kind: 'choice-list',
      label: 'Module',
      kind_options: {
        list_style: 'select',
        values: {}
      },
      validations: {
        required: true
      },
      category: 'Module details'
    },
    title: {
      order: 2,
      kind: 'text',
      label: 'Title',
      validations: {
        required: true
      },
      category: 'Module details'
    },
    tagline: {
      order: 3,
      kind: 'text',
      label: 'Tagline',
      validations: {
        max: 80,
        required: true
      },
      category: 'Module details'
    },
    categories: {
      order: 4,
      kind: 'list',
      label: 'Categories',
      kind_options: {
        item_kind: 'choice-list',
        values: CATEGORIES
      },
      category: 'Module details'
    },
    icon: {
      order: 5,
      kind: 'file',
      label: 'icon',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Module details'
    },
    private: {
      order: 6,
      kind: 'choice',
      label: 'Visibility',
      kind_options: {
        list_style: 'select',
        values: {
          public: 'Public',
          private: 'Private'
        }
      },
      validations: {
        required: true
      },
      default: 'public',
      category: 'Module details'
    },
    paid: {
      order: 7,
      kind: 'boolean',
      label: 'Paid',
      category: 'Module details'
    },
    paid_add_on: {
      order: 8,
      kind: 'boolean',
      label: 'Paid add-on',
      category: 'Module details'
    },
    beta: {
      order: 9,
      kind: 'boolean',
      label: 'Beta',
      category: 'Module details'
    },
    stage_url: {
      order: 10,
      kind: 'url',
      label: 'Beta contact url',
      category: 'Module details'
    },
    version: {
      order: 1,
      kind: 'choice',
      label: 'Version',
      kind_options: {
        list_style: 'select',
        values: {}
      },
      category: 'Version documentation'
    },
    state: {
      order: 2,
      kind: 'choice',
      label: 'Status',
      kind_options: {
        list_style: 'select',
        values: {
          draft: 'Draft',
          published: 'Published'
        }
      },
      validations: {
        required: true
      },
      category: 'Version documentation',
      default: 'draft'
    },
    image_1: {
      order: 3,
      kind: 'file',
      label: 'Image 1',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Version documentation'
    },
    image_2: {
      order: 4,
      kind: 'file',
      label: 'Image 2',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Version documentation'
    },
    image_3: {
      order: 5,
      kind: 'file',
      label: 'Image 3',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Version documentation'
    },
    image_4: {
      order: 6,
      kind: 'file',
      label: 'Image 4',
      kind_options: {
        button_label: 'Select file',
        accept: 'image/*'
      },
      validations: {
        maxFileSize: 5
      },
      category: 'Version documentation'
    },
    changelog: {
      order: 7,
      kind: 'html',
      label: 'What\'s new?',
      tooltip: 'Tell users what has changed with the new version of this module',
      kind_options: {
        rows: 10
      },
      validations: {
        required: true
      },
      category: 'Version documentation'
    },
    description: {
      order: 8,
      kind: 'html',
      label: 'Description',
      tooltip: 'This field supports Markdown and HTML',
      kind_options: {
        rows: 10
      },
      validations: {
        required: true
      },
      category: 'Version documentation'
    },
    description_url: {
      order: 9,
      kind: 'url',
      label: 'Documentation URL',
      tooltip: 'Paste here the link to the documentation for this module',
      category: 'Version documentation'
    }
  };
};

/**
 * Prepares data for the listing of packages
 *
 * @param {array} pkgs
 * @param {array} versions
 * @returns {array}
 */
var getPackageList = function getPackageList(pkgs, versions) {
  return pkgs.map(function (pkg) {
    var latestVersion = versions[pkg.name].latest;
    var hasLatestDraft = pkg.latestDraft === latestVersion;
    var hasNewVersion = !hasLatestDraft && pkg.latestPublished !== latestVersion;
    var latestDescVersion = semver.gt(pkg.latestPublished || '0.0.0', pkg.latestDraft || '0.0.0') ? pkg.latestPublished : pkg.latestDraft;
    return Object.assign(pkg, {
      latestVersion: latestVersion,
      hasLatestDraft: hasLatestDraft,
      hasNewVersion: hasNewVersion,
      latestDescVersion: latestDescVersion
    });
  });
};

/**
 * Prepares values for package dropdown
 *
 * @param {array} pkgs
 * @param {array} versions
 * @returns {object}
 */
var getPkgNameOptions = function getPkgNameOptions(pkgs, versions) {
  var names = Object.keys(versions);
  var namesWithDesc = _.chain(pkgs).pluck('name').unique().value();
  var namesWithoutDesc = _.difference(names, namesWithDesc);
  return _.object(namesWithoutDesc, _.map(namesWithoutDesc, function (name) {
    return "pkg-".concat(name);
  }));
};

/**
 * Prepares values for version dropdown
 *
 * @param {array} versions
 * @returns {object}
 */
var getVersionOptions = function getVersionOptions(versions) {
  var result = {};
  for (var _i = 0, _Object$keys = Object.keys(versions); _i < _Object$keys.length; _i++) {
    var pkgName = _Object$keys[_i];
    result[pkgName] = _.object(versions[pkgName].versions, versions[pkgName].versions);
  }
  return result;
};

/**
 * Checks changes in name and version dropdowns
 * When name changes, it loads correct values in the
 * version dropdown.
 * When version changes, it loads description for given/latest matching
 * version and sets the model values (only in edit mode).
 *
 * @param {OrgPackageManager} ctrl
 */
var prepareModalData = function prepareModalData(ctrl) {
  var pkgName = ctrl.model.name;
  if (pkgName !== ctrl.prevPkgName) {
    if (pkgName) {
      ctrl.moduleDetailsFields.version.kind_options.values = ctrl.versionOptions[pkgName];
      if (!ctrl.isEditModal) {
        ctrl.model.version = ctrl.versions[pkgName].latest;
      }
    } else {
      ctrl.moduleDetailsFields.version.kind_options.values = {};
      delete ctrl.model.version;
    }
    ctrl.prevPkgName = pkgName;
  }
  var version = ctrl.model.version;
  if (ctrl.isEditModal && version && version !== ctrl.prevVersion) {
    ctrl.prevVersion = version;
    return updateModelWithDesc(ctrl, pkgName, version);
  }
};

/**
 * Tries to get package description for given version from the API.
 * The API returns either description object or the 404 error code with
 * the latest available description.
 *
 * @param {OrgPackageManager} ctrl
 * @param {string} pkgName
 * @param {string} version
 */
var updateModelWithDesc = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(ctrl, pkgName, version) {
    var _i2, _Object$keys2, key, desc, latestMatchingVersion;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // dont use _.pick here as it makes copy of object and the modal flashes
          for (_i2 = 0, _Object$keys2 = Object.keys(ctrl.model); _i2 < _Object$keys2.length; _i2++) {
            key = _Object$keys2[_i2];
            if (key !== 'name' && key !== 'version') {
              delete ctrl.model[key];
            }
          }
          desc = null;
          _context.prev = 2;
          _context.next = 5;
          return ctrl.packageManagerService.getPackageDescription(ctrl.orgId, pkgName, version);
        case 5:
          desc = _context.sent;
          _context.next = 18;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](2);
          if (!(_context.t0.response.status === 404 && _context.t0.response.data.latest_matching_description)) {
            _context.next = 17;
            break;
          }
          latestMatchingVersion = _context.t0.response.data.latest_matching_description;
          _context.next = 14;
          return ctrl.packageManagerService.getPackageDescription(ctrl.orgId, pkgName, latestMatchingVersion);
        case 14:
          desc = _context.sent;
          _context.next = 18;
          break;
        case 17:
          console.log('Latest matching description not found.');
        case 18:
          if (desc) {
            setDescToModel(ctrl, desc);
          }
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 8]]);
  }));
  return function updateModelWithDesc(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Transforms the description object from API to model.
 *
 * @param {OrgPackageManager} ctrl
 * @param {object} desc
 */
var setDescToModel = function setDescToModel(ctrl, desc) {
  var getImagePlaceholder = function getImagePlaceholder(key) {
    return {
      name: key,
      size: 0,
      // to pass validation
      uploaded: true
    };
  };
  desc.private = desc.private ? 'private' : 'public';
  desc.icon = desc.icon ? getImagePlaceholder('icon') : null;
  desc.beta = desc.stage === STAGE_BETA;
  var imageKeys = IMAGE_KEYS.filter(function (key) {
    return key !== 'icon';
  });
  var imageVals = imageKeys.map(function (key, idx) {
    return desc.images[idx] ? getImagePlaceholder(key) : null;
  });
  _.extend(desc, _.object(imageKeys, imageVals));
  ctrl.desc = desc;

  // omit the version property so we don't override the one in the model in
  // case of last matching description
  _.extend(ctrl.model, _.omit(desc, 'version', 'stage'));
};
var OrgPackageManager = /*#__PURE__*/function () {
  OrgPackageManager.$inject = ["$route", "$rootScope", "packageManagerService", "modalService"];
  /* @ngInject */
  function OrgPackageManager($route, $rootScope, packageManagerService, modalService) {
    _classCallCheck(this, OrgPackageManager);
    this.$route = $route;
    this.$rootScope = $rootScope;
    this.packageManagerService = packageManagerService;
    this.modalService = modalService;
    this.filtered = [];
    this.model = {};
  }
  return _createClass(OrgPackageManager, [{
    key: "$onInit",
    value: function () {
      var _$onInit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var pkgs, versions, _yield$Promise$all, _yield$Promise$all2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loading = true;
              this.orgId = this.organisation._id;
              _context2.prev = 2;
              _context2.next = 5;
              return Promise.all([this.packageManagerService.getPackageDescriptions(this.orgId), this.packageManagerService.getOrgPackageVersions(this.orgId)]);
            case 5:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              pkgs = _yield$Promise$all2[0];
              versions = _yield$Promise$all2[1];
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](2);
              console.log('Failed to load packages.', _context2.t0);
            case 14:
              this.versions = versions;
              this.packages = getPackageList(pkgs, versions);
              this.pkgNameOptions = getPkgNameOptions(pkgs, versions);
              this.versionOptions = getVersionOptions(versions);
              this.loading = false;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 11]]);
      }));
      function $onInit() {
        return _$onInit.apply(this, arguments);
      }
      return $onInit;
    }()
  }, {
    key: "$doCheck",
    value: function $doCheck() {
      if (!this.isModalOpened) {
        return;
      }
      prepareModalData(this);
    }
  }, {
    key: "hasPkgsWithoutDesc",
    value: function hasPkgsWithoutDesc() {
      return !_.isEmpty(this.pkgNameOptions);
    }
  }, {
    key: "showNewDescriptionModal",
    value: function showNewDescriptionModal() {
      this.isEditModal = false;
      this.isModalOpened = true;
      this.moduleDetailsFields = getModuleDetailsFields();
      this.moduleDetailsFields.name.kind_options.values = this.pkgNameOptions;
      this.descFormModal = this.modalService.openModal({
        templateUrl: '/src/angular/components/orgs/view-org/org-package-manager/org-package-description-modal.html',
        scope: {
          $ctrl: this
        },
        cssClasses: 'org-package-manager-modal'
      });
    }
  }, {
    key: "showEditDescriptionModal",
    value: function () {
      var _showEditDescriptionModal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(pkgRow) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.isEditModal = true;
              this.model.name = pkgRow.name;
              this.model.version = pkgRow.latestDescVersion;
              this.moduleDetailsFields = getModuleDetailsFields();
              this.moduleDetailsFields.name.kind_options.values = _defineProperty({}, pkgRow.name, "pkg-".concat(pkgRow.name));
              if (pkgRow.hasLatestDraft) {
                this.moduleDetailsFields.version.label_html = '<span class=\'badge badge-draft\'>Draft</span>';
              }
              if (pkgRow.hasNewVersion) {
                this.moduleDetailsFields.version.label_html = '<span class=\'badge badge-new-version\'>New version!</span>';
              }
              _context3.next = 9;
              return prepareModalData(this);
            case 9:
              this.isModalOpened = true;
              this.descFormModal = this.modalService.openModal({
                templateUrl: '/src/angular/components/orgs/view-org/org-package-manager/org-package-description-modal.html',
                scope: {
                  $ctrl: this
                },
                cssClasses: 'org-package-manager-modal'
              });
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function showEditDescriptionModal(_x4) {
        return _showEditDescriptionModal.apply(this, arguments);
      }
      return showEditDescriptionModal;
    }()
  }, {
    key: "closeDescriptionModal",
    value: function closeDescriptionModal() {
      this.descFormModal.close();
      this.model = {};
      this.prevPkgName = null;
      this.prevVersion = null;
      this.isModalOpened = false;
    }
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$model, packageName, version, images, result, imagesToDelete, _i3, _Object$keys3, imageId, _i4, _imagesToDelete, _imageId;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this$model = this.model, packageName = _this$model.name, version = _this$model.version;
              this.saving = true;
              this.model.private = this.model.private === 'private' ? true : false;

              // normalize description and changelog until BST-95 is fixed
              this.model.changelog = this.model.changelog || ' ';
              this.model.description = this.model.description || ' ';
              if (!(this.model.beta && !this.model.stage_url)) {
                _context4.next = 8;
                break;
              }
              this.saving = false;
              return _context4.abrupt("return", this.$rootScope.setFlashMessage('Beta contact Url is a required field for beta modules', 'warning'));
            case 8:
              this.model.stage = this.model.beta ? STAGE_BETA : null;
              this.model.stage_url = this.model.beta ? this.model.stage_url : null;
              images = _.pick(this.model, IMAGE_KEYS);
              images = _.omit(images, function (image) {
                return (image || {}).uploaded;
              });
              _context4.prev = 12;
              result = true;
              imagesToDelete = [];
              _i3 = 0, _Object$keys3 = Object.keys(images);
            case 16:
              if (!(_i3 < _Object$keys3.length)) {
                _context4.next = 29;
                break;
              }
              imageId = _Object$keys3[_i3];
              if (!images[imageId]) {
                _context4.next = 25;
                break;
              }
              _context4.t0 = result;
              _context4.next = 22;
              return this.packageManagerService.savePackageImage(this.orgId, packageName, version, imageId, images[imageId]);
            case 22:
              result = _context4.t0 &= _context4.sent;
              _context4.next = 26;
              break;
            case 25:
              if (this.desc[imageId]) {
                imagesToDelete.push(imageId);
              }
            case 26:
              _i3++;
              _context4.next = 16;
              break;
            case 29:
              _context4.next = 31;
              return this.packageManagerService.savePackageDescription(this.orgId, packageName, version, this.model);
            case 31:
              result = _context4.sent;
              _i4 = 0, _imagesToDelete = imagesToDelete;
            case 33:
              if (!(_i4 < _imagesToDelete.length)) {
                _context4.next = 42;
                break;
              }
              _imageId = _imagesToDelete[_i4];
              _context4.t1 = result;
              _context4.next = 38;
              return this.packageManagerService.deletePackageImage(this.orgId, packageName, version, _imageId);
            case 38:
              result = _context4.t1 &= _context4.sent;
            case 39:
              _i4++;
              _context4.next = 33;
              break;
            case 42:
              if (result) {
                _context4.next = 44;
                break;
              }
              throw new Error('Failed to save package description.');
            case 44:
              _context4.next = 51;
              break;
            case 46:
              _context4.prev = 46;
              _context4.t2 = _context4["catch"](12);
              console.log(_context4.t2);
              this.saving = false;
              return _context4.abrupt("return", this.$rootScope.setFlashMessage('Failed to save package description.', 'danger'));
            case 51:
              this.closeDescriptionModal();
              this.saving = false;
              this.$rootScope.setFlashMessage('Package description saved successfully.');
              return _context4.abrupt("return", this.$route.reload());
            case 55:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[12, 46]]);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.package-manager', ['backstage.services']).component('bsOrgPackageManager', {
  templateUrl: '/src/angular/components/orgs/view-org/org-package-manager/org-package-manager.html',
  bindings: {
    organisation: '<'
  },
  controller: OrgPackageManager
}).name;